export default {"src":"__ASTRO_ASSET_IMAGE__Cv5L5Ybh__","width":324,"height":207,"format":"png"}